import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { AdministrationUserCreateForm } from 'types';
import { useStyles } from './styles';
import { AdministrationUserCreateStepProps } from './types';

export const Step1: React.FC<AdministrationUserCreateStepProps> = ({ onSubmit, formName, previousStepData }) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });

  const { handleSubmit } = useForm<AdministrationUserCreateForm>({
    mode: 'onBlur',
    defaultValues: previousStepData,
  });

  return (
    <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
      <Box className={classes.boxReminder}>
        <Typography>{t('step1.reminderText1')}</Typography>
        <Typography>{t('step1.reminderText2')}</Typography>
        <Typography>{t('step1.reminderText3')}</Typography>
        <Typography>
          {t('step1.reminderText4Start')}
          <a href={`mailto:dpd@citeo.com?subject=${encodeURIComponent(`Support pour RGPD`)}`}>{t('step1.mailto')}</a>
          {t('step1.reminderText4End')}
          <Link to="/politique-de-confidentialite.pdf" target="_blank" download>
            {t('step1.privacyPolicy')}
          </Link>
          .
        </Typography>
      </Box>
    </form>
  );
};
